import { SVGProps } from "react";

type Props = SVGProps<SVGSVGElement> & {
  color?: string;
  size?: number;
};

const SvgPlusIcon = ({ color, size = 40, ...props }: Props) => {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id="svg-wrapper"
      transform={`scale(${size / 40})`}
      style={{ WebkitTransform: `scale(${size / 40})` }}
      {...props}
    >
      <path
        d="M31.025 17.942h-8.083a3.614 3.614 0 0 0-.4-.484 3.62 3.62 0 0 0-.484-.4V8.975a.52.52 0 0 0-.516-.517H18.45a.52.52 0 0 0-.517.517v8.083a3.62 3.62 0 0 0-.483.4c-.15.15-.283.317-.4.484H8.975a.52.52 0 0 0-.516.516v3.092a.52.52 0 0 0 .516.517h8.083c.117.166.25.333.4.483.15.15.317.283.484.4v8.083a.52.52 0 0 0 .517.517h3.091a.52.52 0 0 0 .517-.517V22.95c.166-.117.333-.25.483-.4.15-.15.284-.317.4-.483h8.084a.52.52 0 0 0 .516-.517v-3.092a.52.52 0 0 0-.517-.516h-.008Z"
        fill={color || "#595959"}
      />
    </svg>
  );
};

export default SvgPlusIcon;
